import { render, staticRenderFns } from "./SuggestedReviews.vue?vue&type=template&id=34216205&scoped=true&"
import script from "./SuggestedReviews.vue?vue&type=script&lang=js&"
export * from "./SuggestedReviews.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedReviews.vue?vue&type=style&index=0&id=34216205&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34216205",
  null
  
)

export default component.exports